/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models{
    export class ClaimsAssignmentConfigurationModel {
        private logType: string = "ClaimsConfigurationModel";

        public processClaims: Wars.Domain.Model.ClaimDefinition[];
        public systemAndProcessClaims: Wars.Domain.Model.ClaimDefinition[];
        public selectedClaim: Wars.Domain.Model.ClaimDefinition;
        public selectedClaimsChildren: Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration[];
        public currentClaimsAssignment: Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration;
        public showAddEditSection: boolean;
        public addingNewClaim: boolean;
        public addClaimsOptions: Wars.Domain.Model.ClaimDefinition[] = [];
        public conditions: Wars.Domain.Model.Conditions.Condition[];
        
        constructor(
            public processConfigurationId: string,
            private claimsAssignmentService: services.ClaimsAssignmentConfigurationService,
            private claimsDefinitionService: services.ClaimDefinitionService,
            private processConfigurationService: services.ProcessConfigurationService,
            private treeService: services.TreeService,
            private conditionService: services.ConditionService,
            private growl: angular.growl.IGrowlService)
        {
            claimsDefinitionService.getAllProcessClaims(processConfigurationId).then((claims) => {
                this.processClaims = claims;
            });

            claimsDefinitionService.getAllProcessAndSystemClaims(processConfigurationId).then((claims) => {
                this.systemAndProcessClaims = claims;
            });

            conditionService.getAllConditions(processConfigurationId).then((conditions) => {
                this.conditions = conditions;
            });
        }

        public selectedClaimChanged() {
            var self = this;
            this.claimsAssignmentService.getAllAssignmentConfigurationClaims(this.processConfigurationId, this.selectedClaim.id).then(
                (claimChildren: Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration[]) => {
                    self.selectedClaimsChildren = claimChildren; 
                    if (claimChildren && claimChildren.length>=1) {
                        self.treeItem =claimChildren[0].assigningClaimValue;
                    }
                    self.setAddOptions();
            });
        }
        public treeItem: Wars.Domain.Model.TreeItem;
        private setAddOptions() {
            //console.log(this.selectedClaimsChildren);
            this.addClaimsOptions = Enumerable.from(this.processClaims).where(processClaimDefinition => {
                return !Enumerable.from(this.selectedClaimsChildren).any(
                    (claimChild) => {
                        return processClaimDefinition.id === claimChild.claimChild_id;
                    });
            }).toArray();
        }

        public getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            return this.treeService.getDisplayName(treeItem);
        }

        public onDrop($event) {
            var droppedTreeItem = this.treeService.getTreeConfigurationItem();

            if (droppedTreeItem.variableType !== this.selectedClaim.valueType) {
                this.growl.error("The value dragged does not match the type of the claim.");
            } else {
                this.treeItem = this.treeService.createTreeItemFromItemDropped();
                if (this.selectedClaimsChildren && this.selectedClaimsChildren.length > 0) {
                    this.selectedClaimsChildren.forEach(c => {
                        c.assigningClaimValue = this.treeItem;
                        c.treeItem_id = this.treeItem.id;
                    });
                    this.claimsAssignmentService.saveAllChanges();
                }
            }
        }

        public deleteClaimAssignment(claimAssignment: Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration) {
            claimAssignment.entityAspect.setDeleted();
            this.saveChanges();
            this.selectedClaimsChildren.remove(claimAssignment);
            this.setAddOptions();
        }

        public editClaimAssignment(claimAssignment: Wars.Domain.Model.Workflow.ClaimsAssignmentConfiguration) {
            this.currentClaimsAssignment = claimAssignment;
            this.showAddEditSection = true;
        }

        public saveChanges() {
            this.claimsAssignmentService.saveAllChanges();
        }

        public addSave() {
            this.currentClaimsAssignment.claimChild_id = this.currentClaimsAssignment.myClaimChild.id;
            this.saveChanges();
            this.showAddEditSection = false;
            this.addingNewClaim = false;
            this.selectedClaimsChildren.push(this.currentClaimsAssignment);
            this.currentClaimsAssignment = null;
            this.setAddOptions();
        }

        public add() {
            this.currentClaimsAssignment = this.claimsAssignmentService.createClaimAssignmentConfiguration();
            this.currentClaimsAssignment.claim_id = this.selectedClaim.id;
            this.currentClaimsAssignment.preventAssignmentRemovalOfSelf = false;

            this.currentClaimsAssignment.processConfiguration_id = this.processConfigurationId;
            if (this.treeItem) {
                this.currentClaimsAssignment.assigningClaimValue = this.treeItem;
                this.currentClaimsAssignment.treeItem_id= this.treeItem.id; 
            } else {
                this.currentClaimsAssignment.treeItem_id = null;
            }

            this.addingNewClaim = true;
            this.showAddEditSection = true;
        }

        public cancel() {
            this.claimsAssignmentService.rejectChanges();
            this.currentClaimsAssignment = null;
            this.showAddEditSection = false;
        }
    }
}